<template>
  <div class="container-login">
    <v-form v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="2">
          </v-col>
          <v-col cols="8">
            <v-row>
              <!-- <v-col cols="12"><div style="height: 100px;"></div></v-col> -->
              <v-col cols="12" class="text-center text-4xl font-semibold">
                <font class="">SmartLink </font><font class="light-blue--text">Platform</font>
              </v-col>
              <v-col cols="12"><div style="height: 80px;"></div></v-col>
              <v-col cols="12" class="text-3xl font-semibold blue--text">
                Forgot your password?
              </v-col>
              <v-col cols="12" class="text-sm blue--text">
                A request to reset your SmartLink Platform password has been made. If you did not make this request, simply ignore this email.<br/>
                If you did make this request, please reset your password:
              </v-col>
              <v-col cols="12">
                <v-btn
                  x-large
                  color="primary"
                  @click="resetPwd()"
                >
                Reset Password</v-btn>
              </v-col>
              <v-col cols="12" class="text-xs light-blue--text">
                If the button above does not work, try copying and pasting the <a @click="$router.push('/createaccount')" class="underline">URL</a> into your browser.<br/>
                If you continue to have problems, please left free to contact us at SmartLink Platform@cyberlogitec.com
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2">
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <dialogWindow
      ref="ResetPasswordDialog"
      :info="checkDialogTitle"
      size="max"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    >
    </dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
  export default {
    components: {
      dialogWindow,
    },
    data: () => ({
      userid: '',
      userpwd: '',
      checkDialogColor: 'success',
      checkDialogTitle: '',
    }),
    
    methods: {
      resetPwd() {
        const path = this.$route.path;
        const arrParams = path? path.split('/') : '';
        const usrId = arrParams[2]? arrParams[2] : '';
        const hashKey = arrParams[3]? arrParams[3] : '';
        const param = {usrId: usrId, hashKey: hashKey}
        this.$store.dispatch('resetPassword', param).then((res) => {
          if (res.status === 0) {
            this.checkDialogColor = 'warning';
            this.checkDialogTitle = res.message;
          } else {
            this.checkDialogColor = 'success';
            this.checkDialogTitle = res.message;
          }
          this.$refs.ResetPasswordDialog.dialog = true;
          console.log("resetPassword ok", res)
        }).catch((err) => {
          console.log("resetPassword", err)
        });
      },
      closeDialog() {
        if (this.checkDialogColor === 'warning') {
          this.$router.push('/forgotpassword');
        } else {
          this.$router.push('/login');
        }
      }
    }
  }
</script>